var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "web_dev",
    "data-name": "web dev",
    xmlns: "http://www.w3.org/2000/svg",
    width: 123.183,
    height: 93.974,
    viewBox: "0 0 123.183 93.974",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_21913",
    "data-name": "Path 21913",
    d: "M100.546,4H26.637C13.052,4,2,14.536,2,27.493V74.48C2,87.437,13.052,97.974,26.637,97.974h73.91c13.585,0,24.637-10.536,24.637-23.493V27.493C125.183,14.536,114.131,4,100.546,4Zm12.318,70.48c0,6.475-5.525,11.747-12.318,11.747H26.637c-6.794,0-12.318-5.271-12.318-11.747V39.24h98.546ZM14.318,27.493c0-6.475,5.525-11.747,12.318-11.747h73.91c6.794,0,12.318,5.271,12.318,11.747Z",
    transform: "translate(-2 -4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.943a0f5ccf82ad7e64c1ebf661552227.svg";
export { ForwardRef as ReactComponent };